export default {"src":"/_next/static/media/Circle-info.3aeeb4c2.svg","height":20,"width":20};